import type { Distribution } from "@memorang/types";
import Box from "../Box";
import DonutChart from "../DonutChart";
import ProductIcon from "../ProductIcon";
import RowStats, { type Stat } from "../RowStats";

/* -----------------Props--------------- */
type Props = {
	distribution: Distribution;
	donutProgressData?: { x: string; y: number }[];
	donutProgressColorScale?: string[];
	title: string;
	image?: string;
	stats?: Stat[];
};

/* -----------------Component--------------- */
const ContentHero = (props: Props) => {
	const {
		distribution,
		donutProgressData,
		donutProgressColorScale,
		stats,
		image,
	} = props;

	return (
		<>
			<Box padding={16} gap={16}>
				{image ? (
					<DonutChart
						distribution={distribution}
						progressData={donutProgressData}
						colorScale={donutProgressColorScale}
						radius={64}
						innerRadius={50}
					>
						<ProductIcon image={image} size={64} />
					</DonutChart>
				) : null}
				{stats?.length ? <RowStats stats={stats || []} /> : null}
			</Box>
		</>
	);
};

export default ContentHero;
